<template>
  <div class="mobile">
    <svg
      :tabindex="index + 4"
      :title="index + 1 + ` ` + labels.star"
      role="button"
      viewBox="0 0 250 250"
      class="svg-star"
      v-for="(answer, index) in question.answers"
      :key="index"
      :aria-pressed="index == clickedIndex ? 'true' : 'false'"
      :id="'star' + (index + 1)"
      @keydown.enter.space="select(answer, index)"
      v-on:mouseover="hoverIndex = index"
      v-on:mouseleave="hoverIndex = undefined"
      v-on:click="select(answer, index)"
    >
      <polygon
        points="120,30 60,218 210,98 30,98 180,218"
        class="star stroke"
      />
      <polygon
        points="120,30 60,218 210,98 30,98 180,218"
        :class="
          'star ' +
            [
              index <= clickedIndex
                ? 'clicked'
                : index <= hoverIndex
                ? 'over'
                : '',
            ]
        "
        :id="'option' + (index + 1)"
      />
    </svg>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: () => {
    return {
      hoverIndex: undefined,
      clickedIndex: undefined,
    }
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.component.starRating
    },
  },
  created: function() {
    for (let i = 0; i < this.question.answers.length; i++) {
      if (
        this.question.answered !== null &&
        this.question.answered.answer_id === this.question.answers[i].answer_id
      ) {
        this.clickedIndex = i
      }
    }
  },
  props: {
    question: undefined,
    selectAnswer: undefined,
  },
  methods: {
    select(id, index) {
      this.clickedIndex = index
      this.$emit('answer', id)
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.mobile {
  @media (max-width: 767px) {
    align-items: center;
    display: flex;
    flex-direction: column-reverse;
  }
}

.svg-star {
  cursor: pointer;
  max-width: 120px;
  min-width: 120px;

  @media (max-width: 1024px) {
    max-width: 110px;
    min-width: 110px;
  }

  @media (max-width: 992px) {
    max-width: 95px;
    min-width: 95px;
  }

  @media (max-width: 767px) {
    max-width: 65px;
    min-width: 65px;
    margin-bottom: 10px;
  }
}

.star {
  stroke-linejoin: round;
  stroke-width: 25;
  stroke: map-get($theme-colors, 'gray-light');
  fill: map-get($theme-colors, 'gray-light');

  &.over {
    stroke-width: 28;
    stroke: map-get($theme-colors, 'gold');
    fill: map-get($theme-colors, 'gold');
  }

  &.clicked {
    stroke-width: 28;
    stroke: map-get($theme-colors, 'tertiary');
    fill: map-get($theme-colors, 'tertiary');
  }

  &.stroke {
    stroke-width: 28;
    stroke: map-get($theme-colors, 'gray00');
    fill: map-get($theme-colors, 'gray00');
  }
}
</style>
